export default {
  title: 'Język',
  save_changes: 'Zapisz zmiany',
};
